import React from "react";
import Page from "../templates/empower/empowerpage";

export default function home() {
  return (
    <div>
      <Page />
    </div>
  );
}
